import React from 'react';
import PaymentOptions from '../../../PaymentOptions';
import PublishModalContent from '../../../PublishModalContent/PublishModalContent';
import './PlanSelectionContent.css';
var defaultProps = {
  show: false
};
export default function PlanSelectionContent(_ref) {
  var show = _ref.show,
      onPlanSelected = _ref.onPlanSelected,
      plans = _ref.plans;
  return /*#__PURE__*/React.createElement(PublishModalContent, {
    show: show,
    backButtonText: "Step 1/2",
    headerText: "Pick your plan!"
  }, /*#__PURE__*/React.createElement("div", {
    className: "clover-plan-selection-content"
  }, /*#__PURE__*/React.createElement(PaymentOptions, {
    plans: plans,
    onPlanSelected: onPlanSelected
  })));
}
PlanSelectionContent.defaultProps = defaultProps;